import React, { Component } from "react";
import Layout from "../../Layout/layout";
import Helmet from "react-helmet";
import "../../styles/profile/profile.scss";
import { Row, Col, Form, Button } from "react-bootstrap";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
import { apiHost } from "../../api/apiClient";
import axios from "axios";

class manageAccount extends Component {

  constructor(props) {
    super(props);
    this.state = {
      changeClick: false,
      oldPassword: "",
      oldPasswordError: false,
      newPassword: "",
      newPasswordError: false,
      newPasswordLengthError: false,
      confirmPassword: "",
      confirmPasswordError: false,
      passwordError: false,
      changeStatus: false,

    };
  }

  handleOldPassword = (e) => {
    if (e.target.value == "") {
      this.setState({ oldPasswordError: true })
    } else {
      this.setState({ oldPassword: e.target.value, oldPasswordError: false });
    }
    console.log(e.target.value);
  };

  handleNewPassword = (e) => {
    if (e.target.value == "") {
      this.setState({ newPasswordError: true })
      this.setState({ newPasswordLengthError: false })

    } else {
      this.setState({ newPasswordError: false })
      this.setState({ newPassword: e.target.value });
      // if (e.target.value.length<6 || e.target.value.length>20) {
      //   this.setState({newPasswordLengthError:true})
      // } else {
      //   this.setState({newPasswordLengthError:false})

      //   this.setState({ newPassword: e.target.value });
      // }
    }
    // console.log(e.target.value);
    if (this.state.confirmPassword != '') {
      if (e.target.value !== this.state.confirmPassword) {
        this.setState({ passwordError: true })
      } else {
        this.setState({ passwordError: false })
      }
    }
  };
  handleConfirmPassword = (e) => {
    console.log(e.target.value);
    if (e.target.value == "") {
      this.setState({ confirmPasswordError: true, passwordError: false })
    } else {
      this.setState({ confirmPasswordError: false })

      if (e.target.value != this.state.newPassword) {
        this.setState({ passwordError: true });
      } else {
        this.setState({ passwordError: false, confirmPassword: e.target.value });
      }
    }
  };

  handlePasswordChange = async () => {
    this.formSubmit = true;
    if (this.state.oldPassword == '') {
      this.setState({ oldPasswordError: true })
      this.formSubmit = false;

    }
    if (this.state.newPassword == '') {
      this.setState({ newPasswordError: true })
      this.formSubmit = false;

    } else {

      if (this.state.newPassword.length < 6 || this.state.newPassword > 20) {
        this.setState({ newPasswordLengthError: true })
        this.formSubmit = false;
      }
    }
    if (this.state.confirmPassword == '') {
      this.setState({ confirmPasswordError: true })
      this.formSubmit = false;

    }

    if (this.state.passwordError == true) {
      this.formSubmit = false;

    }
    if (this.formSubmit) {

      this.props.setLoadingPageAction(true);
      try {
        const response = await axios.post(
          `${apiHost}/api/Auth/ResetPassword`,
          {
            CurrentPassword: this.state.oldPassword,
            NewPassword: this.state.newPassword,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );
        if (response.status == "200") {
          this.setState({
            timeZoneArr: response.data,
            changeStatus: true,
          });
          this.props.setLoadingPageAction(false);
        }
      } catch (e) {
        if (e.response.status == "401") {
          this.props.history.push("/login");
        } else {
          this.props.setErrorMessageAction(`${e}`)

        }
        console.log("e.response", e.response)
        this.props.setLoadingPageAction(false);

        console.log(`😱 Axios request failed: ${e}`);
      }
    }
    this.setState({
      oldPassword: " ",
      newPassword: " ",
      confirmPassword: " "
    });

  };

  render() {
    return (
      <Layout>
        <Helmet>
          <title>Manage Accout</title>
        </Helmet>
        <div className="containerWrapperProfile">
          <div className="containerBody">
            <h1>Manage Account</h1>
            <span>
              {this.state.changeClick
                ? "Change Password Form"
                : "Change Your Account Settings"}
            </span>
            <hr />
            {this.state.changeStatus &&
              <p style={{ fontSize: '20px', position: 'relative', top: '-10px' }}>Password has been changed</p>
            }
            {this.state.changeClick ? (
              <div className="changePasswordSection">
                <Row>
                  <Col sm="3">
                    <h6>Current Password</h6>
                  </Col>
                  <Col sm="4">
                    <Form>
                      <Form.Group controlId="exampleForm.ControlInput1">
                        <Form.Control
                          type="password"
                          onChange={this.handleOldPassword}
                          placeholder=""
                        />
                      </Form.Group>
                    </Form>
                    <p style={this.state.oldPasswordError ? { color: '#a94442', fontSize: '14px', position: 'relative', top: '-10px' } : { display: 'none' }}>The Current Password field is required.</p>
                  </Col>
                </Row>
                <Row>
                  <Col sm="3">
                    <h6>New Password</h6>
                  </Col>
                  <Col sm="4">
                    <Form>
                      <Form.Group controlId="exampleForm.ControlInput1">

                        <Form.Control type="password" onChange={this.handleNewPassword} placeholder="" />
                      </Form.Group>
                    </Form>
                    <p style={this.state.newPasswordError ? { color: '#a94442', fontSize: '14px', position: 'relative', top: '-10px' } : { display: 'none' }}>The New Password field is required.</p>
                  </Col>
                </Row>
                <Row>
                  <Col sm="3">
                    <h6>Confirm New Password</h6>
                  </Col>
                  <Col sm="4">
                    <Form>
                      <Form.Group controlId="exampleForm.ControlInput1">
                        <Form.Control type="password" onChange={this.handleConfirmPassword} placeholder="" />
                      </Form.Group>
                    </Form>
                    <p style={this.state.confirmPasswordError ? { color: '#a94442', fontSize: '14px', position: 'relative', top: '-10px' } : { display: 'none' }}>The Confirm Password field is required.</p>
                    <p style={this.state.passwordError ? { color: '#a94442', fontSize: '14px', position: 'relative', top: '-10px' } : { display: 'none' }}>Password Doesnot Match. </p>
                  </Col>
                </Row>
                <Row>
                  <Col sm="3">{/* <h6 >Current Password</h6> */}</Col>
                  <Col sm="4">
                    <Button variant="primary" onClick={this.handlePasswordChange}>Change Password</Button>
                    &nbsp;&nbsp;
                    <Button
                      variant="outline-secondary"
                      onClick={() => {
                        this.setState({ changeClick: false });
                      }}
                    >
                      Back
                    </Button>
                  </Col>
                </Row>
              </div>
            ) : (
              <p>
                Password:{" "}
                <span
                  onClick={() => {
                    this.setState({ changeClick: true });
                  }}
                >
                  [Change]
                </span>
              </p>
            )}
          </div>
        </div>
        <br />
        <br />
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(manageAccount);
